import type { StylesConfig } from 'react-select';

import type { OptionType } from '#/components/Select/Select.types';
import { colors } from '#/theme/theme';

export function algoliaSearchSelectStyles<T>(): StylesConfig<
  OptionType<T>,
  false,
  never
> {
  return {
    container: (base) => ({
      ...base,
      display: 'block',
      width: '100%',
      minHeight: '45px',
      verticalAlign: 'middle',
      color: colors.mediumContentGrey,
      fontSize: '18px',
    }),
    control: (base, state) => ({
      ...base,
      borderRadius: '8px',
      backgroundColor: state.isDisabled ? colors.inputGrey : 'white',
      width: '100%',
      minHeight: '45px',
      margin: '0',
      cursor: 'pointer',
    }),
    input: (base) => ({
      ...base,
      height: '100%',
      paddingLeft: '0',
    }),
    valueContainer: (base) => ({
      ...base,
      padding: '0 12px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      paddingTop: '2px',
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: 'none',
    }),
    menu: (base) => ({
      ...base,
      zIndex: '5',
      marginTop: '1px',
      borderRadius: '8px',
      boxShadow: '0 1px 5px 0 rgba(0, 0, 0, 0.15)',
      border: `solid 1px ${colors.elementGrey}`,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 10_000_1,
    }),

    menuList: (base) => ({
      ...base,
      padding: '0',
    }),

    option: (base, state) => ({
      ...base,
      display: 'flex',
      alignItems: 'center',
      borderBottom: `solid 1px ${colors.elementGrey}`,
      color: state.isDisabled ? '#999999' : colors.mediumContentGrey,
      padding: '0 12px',
      minHeight: '45px',
      cursor: 'pointer',
      backgroundColor:
        !state.isDisabled && (state.isFocused || state.isSelected)
          ? 'rgba(241, 241, 241, 1)'
          : 'none',
      ':first-of-type': {
        borderTopLeftRadius: '8px',
        borderTopRightRadius: '8px',
      },
      ':last-of-type': {
        borderBottom: 'none',
        borderBottomLeftRadius: '8px',
        borderBottomRightRadius: '8px',
      },
    }),
  };
}
